export default "__VITE_PUBLIC_ASSET__df543729__"